
<div class="card flex justify-content-center">
    <p-toast></p-toast>
</div>